import { useState, useEffect } from 'react';
import axiosInstance from '../axios';

export default function useLocationGraphConfig({ locationNum, limitsEndpoint, scalesEndpoint }) {
	const [locationInfo, setLocationInfo] = useState({});
	const [limitData, setLimitData] = useState([]);
	const [graphScalesData, setGraphScalesData] = useState(null);

	// data loading state
	const [isLoading, setIsLoading] = useState(false);

	// Generic data fetch helper
	const fetchData = async (url, setter, defaultValue = {}) => {
		setIsLoading(true);
		try {
			const response = await axiosInstance.get(url);
			setter(response.data);
		} catch {
			setter(defaultValue);
		} finally {
			setIsLoading(false);
		}
	};

	// Fetch location info
	useEffect(() => {
		if (locationNum) {
			fetchData(`/loc/${locationNum}/size/`, setLocationInfo, {});
		}
	}, [locationNum]);

	// Fetch limit data when locationNum or limitsEndpoint changes
	useEffect(() => {
		if (locationNum) {
			fetchData(limitsEndpoint, setLimitData, []);
		}
	}, [locationNum, limitsEndpoint]);

	// Fetch graph scales data when locationNum or scalesEndpoint changes
	useEffect(() => {
		if (locationNum) {
			fetchData(scalesEndpoint, setGraphScalesData, null);
		}
	}, [locationNum, scalesEndpoint]);

	return { locationInfo, limitData, setLimitData, graphScalesData, setGraphScalesData, isLoading, setIsLoading };
}

// Get the overall minimum and maximum limits from the limit data
export function ComputeScaleExtremes(graphScalesData) { 
	// Initialize extremes
	const overall_extremes = {
		voltage: {
			max: null,
			min: null,
			discharge_min: null,
		},
		impedance: {
			max: null,
			min: null,
		},
		temperature: {
			max: null,
			min: null,
		},
	};

	if (!Array.isArray(graphScalesData) || graphScalesData.length === 0) {
		return overall_extremes;
	}

	graphScalesData.forEach(unit => {
		// Voltage
		if (unit.voltage) {
			const { max, min, discharge_min } = unit.voltage;
			if (typeof max === 'number') {
				overall_extremes.voltage.max = (overall_extremes.voltage.max === null) ? max : Math.max(overall_extremes.voltage.max, max);
			}
			if (typeof min === 'number') {
				overall_extremes.voltage.min = (overall_extremes.voltage.min === null) ? min : Math.min(overall_extremes.voltage.min, min);
			}
			if (typeof discharge_min === 'number') {
				overall_extremes.voltage.discharge_min = (overall_extremes.voltage.discharge_min === null) ? discharge_min : Math.min(overall_extremes.voltage.discharge_min, discharge_min);
			}
		}

		// Impedance
		if (unit.impedance) {
			const { max, min } = unit.impedance;
			if (typeof max === 'number') {
				overall_extremes.impedance.max = (overall_extremes.impedance.max === null) ? max : Math.max(overall_extremes.impedance.max, max);
			}
			if (typeof min === 'number') {
				overall_extremes.impedance.min = (overall_extremes.impedance.min === null) ? min : Math.min(overall_extremes.impedance.min, min);
			}
		}
		
		// Temperature
		if (unit.temperature) {
			const { max, min } = unit.temperature;
			if (typeof max === 'number') {
				overall_extremes.temperature.max = (overall_extremes.temperature.max === null) ? max : Math.max(overall_extremes.temperature.max, max);
			}
			if (typeof min === 'number') {
				overall_extremes.temperature.min = (overall_extremes.temperature.min === null) ? min : Math.min(overall_extremes.temperature.min, min);
			}
		}
	});

	return overall_extremes;
}